var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-btn',{attrs:{"color":"blue darken-2","loading":_vm.loading,"text":_vm.$t('common.reload'),"icon":"mdi-reload"},on:{"press":_setup.press}})
}
var staticRenderFns = []

export { render, staticRenderFns }